const config = {
  waCowo: `https://api.whatsapp.com/send?phone=6281290540789`,
};
export default config;
